const mapboxgl = require("mapbox-gl");
const _ = require("lodash");
const centroid = require("@turf/centroid").default;
const chroma = require("chroma-js");
const geojson_points = require("./data/healthcare-linedelim-match.json");
const segmentInsert = require("@mapbox/segmentio-insert");

const d = document;

mapboxgl.accessToken = "pk.eyJ1IjoiY2hyaXN0b29tZXkiLCJhIjoiY2phMnVxc2p4M2NmbTM0cGM4aXpscGtmZyJ9.Pap5yG2c5LwCWAXuQwq7pg";
const analytics = segmentInsert("fl0c8p240n");
analytics.track("Demo Viewed", {
  name: "vt_tile_query"
});

let counter = 1;
geojson_points.features.forEach(point => {
  point.id = counter;
  counter++;
});

const map = new mapboxgl.Map({
  container: "map",
  style: "mapbox://styles/mapbox/light-v9?optimize=true",
  center: [-98, 39.8],
  zoom: 3
});

const drillup_el = document.getElementById("defaultView");

drillup_el.addEventListener("click", () => {
  map.easeTo({
    center: [-98, 39.8],
    zoom: 3,
    duration: 1000
  });
});

map.on("zoomend", () => {
  if (map.getZoom() >= 6) {
    drillup_el.style.visibility = "visible";
  } else {
    drillup_el.style.visibility = "hidden";
  }

});

map.addControl(new mapboxgl.NavigationControl());

map.on("style.load", () => {

});
// Calculate the domains of values for each property

let point_domain = [];
const allfeat_props = [];
// const id = 0;

geojson_points.features.forEach(f => {
  allfeat_props.push(f.properties);
  point_domain.push(f.properties["Avg Medicare Payments"]);
});

// Calculate the aggregate values of a property by polygon

const admin1_groups = _(allfeat_props).groupBy("admin1_id").map((v, k) => ({
  [k]: _.meanBy(v, "Avg Medicare Payments")
})).value();

const admin2_groups = _(allfeat_props).groupBy("admin2_id").map((v, k) => ({
  [k]: _.meanBy(v, "Avg Medicare Payments")
})).value();

// Create domains for color ranges
const admin1poly_domain = [];
const admin2poly_domain = [];

admin1_groups.forEach(k => {
  admin1poly_domain.push(Object.values(k)[0]);
});
admin2_groups.forEach(k => {
  admin2poly_domain.push(Object.values(k)[0]);
});

// Use the data-join technique to generate a color data driven style
let admin1_colorStops = [];
const admin1_filter = ["in", "id"];

let admin2_colorStops = [];
const admin2_filter = ["in", "id"];

// Generate color scale
const admin1_domain = chroma.limits(admin1poly_domain, "k", 10).slice(0, 9);
const admin2_domain = chroma.limits(admin2poly_domain, "k", 10).slice(0, 9);
point_domain = chroma.limits(point_domain, "k", 10).slice(0, 9);

const admin1_scale = chroma.scale(chroma.brewer.YlGnBu).domain(admin1_domain).mode("lab");
const admin2_scale = chroma.scale(chroma.brewer.YlGnBu).domain(admin2_domain).mode("lab");
const point_scale = chroma.scale(chroma.brewer.YlGnBu).domain(point_domain).mode("lab");

admin1_colorStops = [];
admin2_colorStops = [];
const point_colorStops = [];

// Create the data-driven style color stops

const admin1_lookup = new Map();
const admin2_lookup = new Map();

admin1_groups.forEach(k => {
  admin1_colorStops.push([Object.keys(k)[0], admin1_scale(Object.values(k)[0]).hex()]);
  admin1_filter.push(Object.keys(k)[0]);
  admin1_lookup[Object.keys(k)[0]] = Math.round(Object.values(k)[0]);
});

admin2_groups.forEach(k => {
  admin2_colorStops.push([Object.keys(k)[0], admin2_scale(Object.values(k)[0]).hex()]);
  admin2_filter.push(Object.keys(k)[0]);
  admin2_lookup[Object.keys(k)[0]] = Math.round(Object.values(k)[0]);
});

point_domain.forEach(val => {
  point_colorStops.push([val, point_scale(val).hex()]);
});

map.on("style.load", () => {

  map.addSource("boundaries", {
    "type": "vector",
    "url": "mapbox://mapbox.enterprise-boundaries-a1-v2,mapbox.enterprise-boundaries-a2-v2"
  });

  map.addSource("points", {
    "type": "geojson",
    "data": geojson_points
  });

  map.addLayer({
    "id": "admin-1",
    "type": "fill",
    "source": "boundaries",
    "source-layer": "boundaries_admin_1",
    "minzoom": 0,
    "maxzoom": 6,
    "paint": {
      "fill-color": {
        "property": "id",
        "type": "categorical",
        "stops": admin1_colorStops
      },
      "fill-outline-color": "grey",
      "fill-opacity": {
        "stops": [
          [0, 0],
          [1, 1],
          [5, 1],
          [6, 0]
        ]
      }
    },
    "filter": admin1_filter
  }, "waterway-label");

  map.addLayer({
    "id": "admin-2",
    "type": "fill",
    "source": "boundaries",
    "source-layer": "boundaries_admin_2",
    "minzoom": 4,
    "maxzoom": 9,
    "paint": {
      "fill-color": {
        "property": "id",
        "type": "categorical",
        "stops": admin2_colorStops
      },
      "fill-outline-color": "grey",
      "fill-opacity": {
        "stops": [
          [4, 0],
          [6, 1],
          [8, 1],
          [9, 0]
        ]
      }
    },
    "filter": admin2_filter
  }, "waterway-label");

  map.addLayer({
    "id": "points",
    "type": "circle",
    "source": "points",
    "minzoom": 7,
    "paint": {
      "circle-color": {
        "property": "Avg Medicare Payments",
        "stops": point_colorStops
      },
      "circle-radius": {
        "stops": [
          [5, 1],
          [20, 16]
        ]
      },
      "circle-opacity": {
        "stops": [
          [7, 0],
          [9, 1]
        ]
      },
      "circle-stroke-color": ["case", ["==", ["feature-state", "hover"], 1], "red", "grey"],
      "circle-stroke-width": {
        "stops": [
          [4, 0.5],
          [20, 5]
        ]
      }
    }
  });

  map.addLayer({
    "id": "admin-1-highlight",
    "type": "line",
    "source": "boundaries",
    "source-layer": "boundaries_admin_1",
    "minzoom": 0,
    "maxzoom": 6,
    "paint": {
      "line-color": ["case", ["==", ["feature-state", "hover"], 1], "red", "rgba(0,0,0,0)"],
      "line-width": 2
    }
  }, "waterway-label");

  map.addLayer({
    "id": "admin-2-highlight",
    "type": "line",
    "source": "boundaries",
    "source-layer": "boundaries_admin_2",
    "minzoom": 6,
    "maxzoom": 9,
    "paint": {
      "line-color": ["case", ["==", ["feature-state", "hover"], 1], "red", "rgba(0,0,0,0)"],
      "line-width": 2
    }
  }, "waterway-label");

  // Create a popup, but don't add it to the map yet.
  const popup = new mapboxgl.Popup({
    closeButton: false,
    closeOnClick: false
  });
  const popup2 = new mapboxgl.Popup({
    closeButton: false,
    closeOnClick: false
  });
  const popup3 = new mapboxgl.Popup({
    closeButton: false,
    closeOnClick: false
  });

  map.on("click", e => {
    const features = map.queryRenderedFeatures(e.point, {
      layers: ["points", "admin-1", "admin-2"]
    });

    if (!features.length) {
      return;
    }
    let myzoom = 0;

    if ((features[0].layer.id === "admin-1") && (map.getZoom() < 5)) {
      myzoom = 6;
    } else if ((features[0].layer.id === "admin-2") && (map.getZoom() > 5)) {
      myzoom = 9;
    } else {
      myzoom = 12;
    }

    map.easeTo({
      "center": centroid(features[0]).geometry.coordinates,
      "zoom": myzoom,
      "duration": 1000
    });
  });
  let hoverIds = [];
  let hoverIds2 = [];
  let hoverIds3 = [];

  const inArray = function (array, element) {
    array.forEach(item => {
      if (item === element) {
        return true;
      } else {
        return false;
      }
    });
  };

  const move = function move(e) {
    const features = map.queryRenderedFeatures(e.point, {
      layers: ["admin-1"]
    });
    const features2 = map.queryRenderedFeatures(e.point, {
      layers: ["admin-2"]
    });
    const features3 = map.queryRenderedFeatures(e.point, {
      layers: ["points"]
    });
    map.getCanvas().style.cursor = "pointer";
    if (features.length) {
      features.forEach(e => {
        if (!inArray(hoverIds, e.id)) {
          hoverIds.push(e.id);
        }
        // hoverIds.pushIfNotExist(e.id);
        map.setFeatureState({
          source: "boundaries",
          sourceLayer: "boundaries_admin_1",
          id: e.id
        }, {
          "hover": 1
        });
      });

      const outerDiv = d.createElement("div");
      outerDiv.setAttribute("class", "flex-parent-inline flex-parent flex-parent--column color-gray-dark");
      const innerLi = d.createElement("li");
      const innerLiText = d.createTextNode(`Avg Hospital Spend: $${admin1_lookup[features[0].properties.id]}`);
      innerLi.appendChild(innerLiText);
      outerDiv.appendChild(innerLi);
      popup.setLngLat(map.unproject(e.point))
        .setDOMContent(outerDiv)
        .addTo(map);

    }
    if (features2.length) {
      features2.forEach(e => {
        if (!inArray(hoverIds2, e.id)) {
          hoverIds2.push(e.id);
        }
        map.setFeatureState({
          source: "boundaries",
          sourceLayer: "boundaries_admin_2",
          id: e.id
        }, {
          "hover": 1
        });
      });
      const outerDiv = d.createElement("div");
      outerDiv.setAttribute("class", "flex-parent-inline flex-parent flex-parent--column color-gray-dark");
      const innerLi = d.createElement("li");
      const innerLiText = d.createTextNode(`Avg Hospital Spend: $${admin2_lookup[features2[0].properties.id]}`);
      innerLi.appendChild(innerLiText);
      outerDiv.appendChild(innerLi);
      popup2.setLngLat(map.unproject(e.point))
        .setDOMContent(outerDiv)
        .addTo(map);

    }
    if (!features.length) {
      hoverIds.forEach(id => {
        map.setFeatureState({
          source: "boundaries",
          sourceLayer: "boundaries_admin_1",
          id: id
        }, {
          "hover": 0
        });
      });
      popup.remove();
      hoverIds = [];
    } else if (hoverIds.length && hoverIds[0] !== features[0].id) {
      hoverIds.forEach(id => {
        map.setFeatureState({
          source: "boundaries",
          sourceLayer: "boundaries_admin_1",
          id: id
        }, {
          "hover": 0
        });
      });
      popup.remove();
      hoverIds = [];
    }
    if (!features2.length) {
      hoverIds2.forEach(id => {
        map.setFeatureState({
          source: "boundaries",
          sourceLayer: "boundaries_admin_2",
          id: id
        }, {
          "hover": 0
        });
      });
      hoverIds2 = [];
      popup2.remove();
    } else if (hoverIds2.length && hoverIds2[0] !== features2[0].id) {
      hoverIds2.forEach(id => {
        map.setFeatureState({
          source: "boundaries",
          sourceLayer: "boundaries_admin_2",
          id: id
        }, {
          "hover": 0
        });
      });
      popup2.remove();
      hoverIds2 = [];
    }
    if (features3.length) {
      features3.forEach(e => {
        if (!inArray(hoverIds3, e.id)) {
          hoverIds3.push(e.id);
        }
        map.setFeatureState({
          source: "points",
          id: e.id
        }, {
          "hover": 1
        });
      });
      const outerDiv = d.createElement("div");
      outerDiv.setAttribute("class", "flex-parent-inline flex-parent flex-parent--column color-gray-dark");
      const innerLi = d.createElement("li");
      const innerLiText = d.createTextNode(`Avg Hospital Spend: $${Math.round(features3[0].properties["Avg Medicare Payments"])}`);
      innerLi.appendChild(innerLiText);
      outerDiv.appendChild(innerLi);
      popup3.setLngLat(map.unproject(e.point))
        .setDOMContent(outerDiv)
        .addTo(map);
    }
    if (!features3.length) {
      hoverIds3.forEach(id => {
        map.setFeatureState({
          source: "points",
          id: id
        }, {
          "hover": 0
        });
      });
      hoverIds3 = [];
      popup3.remove();
      hoverIds3.forEach(id => {
        map.setFeatureState({
          source: "points",
          id: id
        }, {
          "hover": 0
        });
      });
      popup3.remove();
      hoverIds3 = [];
    }
  };

  map.on("mousemove", move);
});
